import { TableRow, TableCell } from '@/components/atoms/Table/Table.type';
import { AccessFlags } from '@/services/innovorder/auth/auth.type';
import { Column, Cell } from 'react-table';
import { PickupPointTableAction } from './types';

export const defaultPickupPointAction: PickupPointTableAction = {
    pickupPointId: null,
    name: null,
    type: null,
    address: null,
    additionalAddressInfo: null,
};

export type PickupPointTableViewModel = {
    headers: Column<TableRow>[];
    rows: TableRow[];
    action: PickupPointTableAction;
    brandId: number;
    restaurantId?: number;
    isLoading: boolean;
    handleRowClick: (
        cell: Cell<TableRow, TableCell<unknown>> | undefined,
        event?: React.MouseEvent<HTMLTableCellElement>,
    ) => void;
    clearAction: () => void;
    toggleCreateModal: () => void;
    toggleEditModal: (pickupPointId: number, name: string, address: string, additionalInfo: string) => void;
    userAccessFlags: Record<AccessFlags, boolean> | undefined;
};
